import request from '@/util/request'

// 赛事信息列表（不分页）
export const getCompetitionList = (data) => {
  return request({
    url: `/api/register/competition/list`,
    method: 'GET',
    data
  })
}

// 赛事信息详情
export const getCompetitionInfo = (id) => {
  return request({
    url: `/api/register/competition/info/${id}`,
    method: 'GET',
  })
}

// 文件下载（blob 流，用于前端自定义保存文件名）
export const downloadCompetitionFile = (data) => {
  return request({
    url: `/api/file/Download`,
    method: 'GET',
    data,
    responseType: 'blob'
  })
}

// 报名信息汇总
export const competitionSumInfo = (data) => {
  return request({
    url: `/api/register/competition/sumInfo`,
    method: 'GET',
    data
  })
}
